export const SET_JOBS = "@cache/SET_JOBS";
export const SET_SUPPLIERS = "@cache/SET_SUPPLIERS";
export const SET_PAYMENTS = "@cache/SET_PAYMENTS";
